export enum EModalUploadProgress {
  UploadInProgress = "uploadInProgress",
  UploadComplete = "uploadComplete",
}
